import { Box, Grid } from "@mui/material";
import NavigationBar from "../widgets/NavigationBar";

import '../../styles/leaderboard.scss';
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import useRanking from "../../hooks/useRanking";
import { useEffect, useState } from "react";
import formatOrdinal from '../../hooks/ordinalFormater.js';

const columns: GridColDef[] = [
    { field: 'place'    , headerName: 'Place'   , flex: 1, headerClassName: "header", sortable: false },
    { field: 'name'     , headerName: 'Name'    , flex: 2, headerClassName: "header", sortable: false },
    { field: 'emissions', headerName: 'CO2'     , flex: 1, headerClassName: "header", sortable: false },
    { field: 'solar'    , headerName: 'Solar'   , flex: 1, headerClassName: "header", sortable: false }
  ];

export default function Leaderboard() {

    const {ranking, place, emissions, solar, getRanking} = useRanking();

    useEffect(() => {
        getRanking();
    }, [JSON.stringify(ranking)]);

    const [placeDisplay, setPlace] = useState("-1th place");

    useEffect(() => {
        setPlace(formatOrdinal(place) + " place");  
    }, [place])

    const [pointsDisplayTop, setPointsTop] = useState("");
    const [pointsDisplayBottom, setPointsBottom] = useState("");

    useEffect(() => {
        setPointsTop(emissions + " emission points");
        setPointsBottom(solar + " solar points");
    }, [emissions, solar])
    
    return(
        <Grid
            container
            direction = "row"
            className = "boxBg">

            <Grid item xs = {12}>
                <Grid
                    container
                    direction="column"
                    justifyContent="flex-start"
                    alignItems="stretch">
                    
                    <Grid item xs = {4}>
                        <Box className = "boxHeader">
                            <h1 className = "rankingDisplay">{placeDisplay}</h1>
                            <Box className = "divider"/>
                            <h2 className = "pointsDisplay">{pointsDisplayTop}</h2>
                            <h2 className = "pointsDisplay">{pointsDisplayBottom}</h2>
                            <p className = "infoText">Charging points are awarded for charging with solar power and departure accuracy.</p>
                        </Box>
                    </Grid>

                    <Grid item xs = {8}>
                        <div className = "tableParent">
                        <DataGrid
                            className = "leaderBoard"
                            rowHeight = {30}
                            rows={ranking}
                            columns={columns}
                            hideFooterPagination
                            disableColumnMenu/>
                        </div>
                    </Grid>

                </Grid>
            </Grid>

            <Grid item xs = {12}>
                <NavigationBar/>
            </Grid>

        </Grid>
    );
}